module.exports = __webpack_public_path__ + "media/images/digivent/Icon-upload-b01f379dc53a3a8596e7ec293f05f178.svg";